import React, { useState, useEffect } from "react";
import { TiMinus, TiPlus } from "react-icons/ti";
import { getUserCredentials } from "../../../api/usuarioApi";
import { getAdminById } from "../../../api/AdminApi";
import { canAccess } from "../../../utils/permissions";

import PagosGastos from "./PagosGastos";
import PagosProfesionales from "./PagosProfesionales";
import PagosProveedores from "./PagosProveedores";
import PagosAnticipos from "./PagosAnticipos";

export default function Pagos() {
  // Secciones plegables
  const [showGastos, setShowGastos] = useState(false);
  const [showProfesionales, setShowProfesionales] = useState(false);
  const [showProveedores, setShowProveedores] = useState(false);
  const [showAnticipos, setShowAnticipos] = useState(false);

  // Permisos y carga
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);

  // 🔹 Verifica permisos de usuario (igual que Liquidaciones)
  useEffect(() => {
    const checkPermission = async () => {
      setLoading(true);
      try {
        const resultUser = await getUserCredentials();
        const USERDATA = await getAdminById(resultUser.IdUsuario);

        const admin = USERDATA?.[0];
        if (!admin || !canAccess(admin, "pagos")) {
          setHasPermission(false);
          setLoading(false);
          return;
        }

        setHasPermission(true);
      } catch (e) {
        console.error("Error al verificar permisos:", e);
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, []);

  // 🔹 Spinner de carga
  if (loading) {
    return (
      <div
        style={{
          minHeight: "60vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          zIndex: 2,
        }}
      >
        <div
          style={{
            width: 38,
            height: 38,
            border: "4px solid #ddd",
            borderTop: "4px solid #1569c9ff",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
        <span style={{ marginLeft: 14, color: "#444", fontSize: 18 }}>
          Cargando...
        </span>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // 🔹 Si no tiene permisos
  if (hasPermission === false) {
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        <h3>No tiene permisos para ver esta información.</h3>
      </div>
    );
  }

  // 🔹 Si aún no hay resultado
  if (hasPermission !== true) return null;

  // ✅ Si tiene permisos, muestra la vista completa
  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-title">Pagos</h4>
      </div>

      <div className="card-body">
        {/* GASTOS */}
        <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12 collapsible-header" onClick={() => setShowGastos(!showGastos)}>
          <h4 className="card-title mb-0 d-flex align-items-center justify-content-between">
            <span>Gastos</span>
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={(event) => { event.stopPropagation(); setShowGastos(!showGastos); }}
              style={{ border: "none", background: "none", boxShadow: "none" }}
              aria-expanded={showGastos}
              aria-label={showGastos ? "Ocultar gastos" : "Mostrar gastos"}
            >
              {showGastos ? <TiMinus size={24} /> : <TiPlus size={24} />}
            </button>
          </h4>
        </div>
        {showGastos && <PagosGastos />}

        {/* PROFESIONALES */}
        <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12 mt-4 collapsible-header" onClick={() => setShowProfesionales(!showProfesionales)}>
          <h4 className="card-title mb-0 d-flex align-items-center justify-content-between">
            <span>Profesionales</span>
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={(event) => { event.stopPropagation(); setShowProfesionales(!showProfesionales); }}
              style={{ border: "none", background: "none", boxShadow: "none" }}
              aria-expanded={showProfesionales}
              aria-label={
                showProfesionales
                  ? "Ocultar profesionales"
                  : "Mostrar profesionales"
              }
            >
              {showProfesionales ? <TiMinus size={24} /> : <TiPlus size={24} />}
            </button>
          </h4>
        </div>
        {showProfesionales && <PagosProfesionales />}

        {/* PROVEEDORES */}
        <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12 mt-4 collapsible-header" onClick={() => setShowProveedores(!showProveedores)}>
          <h4 className="card-title mb-0 d-flex align-items-center justify-content-between">
            <span>Proveedores</span>
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={(event) => { event.stopPropagation(); setShowProveedores(!showProveedores); }}
              style={{ border: "none", background: "none", boxShadow: "none" }}
              aria-expanded={showProveedores}
              aria-label={
                showProveedores
                  ? "Ocultar proveedores"
                  : "Mostrar proveedores"
              }
            >
              {showProveedores ? <TiMinus size={24} /> : <TiPlus size={24} />}
            </button>
          </h4>
        </div>
        {showProveedores && <PagosProveedores />}

        {/* ANTICIPOS */}
        <div className="col-xl-12 col-lg-12 col-xxl-12 col-sm-12 mt-4 collapsible-header" onClick={() => setShowAnticipos(!showAnticipos)}>
          <h4 className="card-title mb-0 d-flex align-items-center justify-content-between">
            <span>Anticipos</span>
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={(event) => { event.stopPropagation(); setShowAnticipos(!showAnticipos); }}
              style={{ border: "none", background: "none", boxShadow: "none" }}
              aria-expanded={showAnticipos}
              aria-label={showAnticipos ? "Ocultar anticipos" : "Mostrar anticipos"}
            >
              {showAnticipos ? <TiMinus size={24} /> : <TiPlus size={24} />}
            </button>
          </h4>
        </div>
        {showAnticipos && <PagosAnticipos />}
      </div>
    </div>
  );
}
